var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { staticClass: "container content-padding" },
      [
        _vm.isEditing
          ? [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c("h2", { staticClass: "mt-5" }, [
                    _vm._v("ขออภัยในความไม่สะดวก")
                  ]),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.editingRemark))])
                ])
              ])
            ]
          : [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c("h2", [
                    _vm._v("โบนัสพิเศษประจำเดือน" + _vm._s(_vm.getBonusTitle()))
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.bonuses, function(bonus) {
                return _c(
                  "div",
                  {
                    key: bonus.id,
                    staticClass: "container",
                    staticStyle: { padding: "0" }
                  },
                  [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v(_vm._s(bonus.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body p-4" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12 text-left" }, [
                            _c(
                              "p",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("รายละเอียดกิจกรรม")]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              domProps: { innerHTML: _vm._s(bonus.description) }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("ของรางวัล")]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _c(
                                "ul",
                                _vm._l(bonus.rewards_json, function(reward) {
                                  return _c("li", { key: reward }, [
                                    _vm._v(_vm._s(reward))
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("เงื่อนไขกิจกรรม")]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _c(
                                "ul",
                                _vm._l(bonus.conditions_json, function(
                                  condition
                                ) {
                                  return _c("li", { key: condition }, [
                                    _vm._v(_vm._s(condition))
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("ระยะเวลากิจกรรม")]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _c("ul", [
                                _c("li", [
                                  _vm._v(_vm._s(_vm.getBonusDateRange(bonus)))
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v("เกณฑ์การพิจารณาคัดเลือกผู้ได้รางวัล")]
                            ),
                            _vm._v(" "),
                            _c("p", [
                              _c(
                                "ul",
                                _vm._l(bonus.criteria_json, function(criteria) {
                                  return _c("li", { key: criteria }, [
                                    _vm._v(_vm._s(criteria))
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _vm._m(0, true)
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              })
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fw-bold" }, [
      _vm._v("💙ビニート💙"),
      _c("br"),
      _vm._v("𝗕𝗲𝗡𝗲𝗮𝘁 บริการสุดหัวใจ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2caf3b80", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2caf3b80","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/ProfessionalBonus.vue
// module id = 1991
// module chunks = 0